import styled from "styled-components";

const ErrorContainer = styled.div`
    min-height: 52vh;
`;

function Error() {

    return (
        <ErrorContainer>
            <h1>Oups 🗿 Cette page n'existe pas</h1>
        </ErrorContainer>
    )
}

export default Error
